export default [
    // *===================Budget============================---*
    {
        path: '/accounting-budget',
            name: 'accounting-budget',
            component: () => import('@/views/accounting/budget/Budget.vue'),
            meta: {
                pageTitle: 'Budget',
                breadcrumb: [
                    {
                        text: 'Budget',
                        active: true,
                    },
                ],
                //permission: 'Permissions.Accounting.View'            
            },
    },
    {
        path: '/accounting-budget-add',
            name: 'accounting-budget-add',
            component: () => import('@/views/accounting/budget/budgetAdd.vue'),
            meta: {
                pageTitle: 'Add New Budget',
                breadcrumb: [
                    {
                        text: 'Budget',
                        active: true,
                    },
                ],
                //permission: 'Permissions.Accounting.View'            
            },
    },
    {
        path: '/budget/edit/:id',
            name: 'budget-edit',
            component: () => import('@/views/accounting/budget/budgetEdit.vue'),
            meta: {
                pageTitle: 'Budget Edit',
                breadcrumb: [
                    {
                        text: 'Budget',
                        active: true,
                    },
                ],
                //permission: 'Permissions.Accounting.View'            
            },
    },
    {
        path: '/budget/report/:id',
            name: 'budget-report',
            component: () => import('@/views/accounting/budget/VarianceReport.vue'),
            meta: {
                pageTitle: 'Budget Variance Report',
                breadcrumb: [
                    {
                        text: 'Budget',
                        active: true,
                    },
                ],
                //permission: 'Permissions.Accounting.View'            
            },
    }
    ]